import { useEffect, useState } from "react";

import { _ExportProject, _GetProjectInfo, _ProjectDataConsolidated } from "../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../theme/Component/usePaginator";
import { ProjectSelectEditor } from "../../RemoteAbstractAction/editors/ProjectSelectEditor";
import { BasicButton } from "../../theme/Component/BasicButton";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { BasicTable } from "../../theme/Component/BasicTable";
import { AccountEditor } from "../../editor/AccountEditor";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { toast } from "react-toastify";
import { UBLInvoiceFactory } from "../../RemoteAbstractAction/components/account/documents/ublsalesaccountantdocument/UBLInvoiceFactory/UBLInvoiceFactory";
import { DocumentsForProjectData } from "./DocumentsForProjectData/DocumentsForProjectData";
import { AdquisitionItemByPaa } from "./AdquisitionItemByPaa";
import { AdquisitionContractByAdquisition } from "./AdquisitionContractByAdquisition";
import { BudgetDocuments } from "./BudgetDocuments";
import AutoChart from "../../../core/graph/AutoChart";
import { DropDown } from "../../theme/Component/DropDown";
import useModal, { MODAL_XL } from "../../theme/Component/hooks/useModal";

interface Props {
    tableName: number;
    documentsTable: any
}

export const DataCatalog = ({ tableName, documentsTable }: Props) => {

    const getinfo = useDataBean(_GetProjectInfo);
    const exportProject = useDataBean(_ExportProject);
    const exportProjectconsolidated = useDataBean(_ProjectDataConsolidated);
    const single = Singleton.getInstance();
    const [form, setForm] = useState<any>({

        IDProject: null,
        ProjectName: null,

    })
    const [Account, setAccount] = useState<any>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [state, setstate] = useState<any>(null)
    const [formato, setFormato] = useState<any>([]);
    const [formatodata, setFormatodata] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const modalGraph = useModal("Grafica", MODAL_XL);
    const [modaldocpres, setModaldocpres] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalpaa, setModalpaa] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcontrac, setModalcontrac] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldocdata, setModaldocdata] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldoc, setModaldoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalfacturas, setModalfacturas] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const paginador = usePaginator();
    useEffect(() => {
        getListavdos();
    }, [paginador.page, tableName])



    const head = [
        { title: 'ID', property: 'IDProjectData', visible: true },
        { title: 'ID Proyecto', property: 'IDProject', visible: true },
        { title: 'Concepto', property: 'AccountantIDName', visible: true },
        { title: 'NIT Patrocinador', property: 'AccountID', visible: true },
        { title: 'Nombre Patrocinador', property: 'AccountName', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Valor a Ejecutar', property: 'TotalValue', visible: true },
        { title: 'Fecha Inicial Proyecto', property: 'ProjectInitDate', visible: true },
        { title: 'Fecha Final Proyecto', property: 'ProjectUptoDate', visible: true },
        { title: 'Fecha Corte Inicial Consulta', property: 'InitialDate', visible: true },
        { title: 'Fecha Corte Final Consulta', property: 'UptoDate', visible: true },
        { title: 'Valor Inicial al Corte', property: 'InitialValue', visible: true },
        // { title: 'Ingresos Realizados', property: 'LeftValue', visible: true },
        // { title: 'Pagos Realizados', property: 'DebtValue', visible: true },
        { title: 'Valor Final por Ejecutar', property: 'EndingValue', visible: true },
    ]
    const getListavdos = () => {

        getinfo.instance.getProjectDataCatalog(tableName, form.IDProject, regexStr, Account, state, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }

            }
        )

    }

    const exportProjectData = () => {


        exportProject.instance.exportProjectData(getinfo.bean.IDProject, tableName, documentsTable).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Balance  Generado');
                    setModaldocdata({ ...modaldocdata, "view": true });
                    setFormatodata(resp[0]);
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const exportProjectDataConsolidated = () => {


        exportProjectconsolidated.instance.exportProjectDataConsolidated(tableName, documentsTable).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Consolidado  Generado');
                    setModaldoc({ ...modaldoc, "view": true });
                    setFormato(resp[0]);
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const actionsDropDown = [
        { id: 1, name: 'Reporte Grafico', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {

                            modalGraph.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }
    const listaBotones = () => {
        const botones = [
            { titulo: 'Generar Balance Financiero', icono: 'ri-edit-2-line', visible: true, evento: () => { exportProjectData() } },
            { titulo: 'Catálogo de PAA', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalpaa({ ...modalpaa, "view": true }) } },
            { titulo: 'Contratos de Adquisición', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalcontrac({ ...modalcontrac, "view": true }) } },
            { titulo: 'Documentos Presupuestales', icono: 'ri-edit-2-line', visible: true, evento: () => { setModaldocpres({ ...modaldocpres, "view": true }) } },
            { titulo: 'Ver Documentos de Ejecución del Proyecto', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },
            { titulo: 'Facturas Pagadas a Terceros por Proyecto', icono: 'ri-file-history-line', visible: true, evento: () => { setModalfacturas({ ...modalfacturas, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    return (
        <div className="row">
            <div className="col-md-6">
                <label>Proyecto</label>
                <ProjectSelectEditor render={form.ProjectName} idSelector={form.IDProject} onChange={(e) => { setForm({ ...form, "IDProject": e.IDProject, "ProjectName": e.Name }) }} label=" " returnType="Object" />
            </div>
            <div className="col-md-6">
                <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} label="Patrocinador" />
            </div>
            <div className="col-md-6">
                <label>Búsqueda por Texto</label>
                <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
            </div>
            <div className="col-md-6">
                <label>Estado</label>
                <input type="text" name="state" className="form-control" value={state} onChange={(e) => { setstate(parseInt(e.target.value)) }} />
            </div>
            <div className="col-md-6 mt-4">
                <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getListavdos}>
                    Buscar
                </BasicButton>
            </div>
            <div className="col-md-6 mt-4">
                <BasicButton icon="ri-profile-line" clase="btn btn-outline-primary btn-border" eventClick={exportProjectDataConsolidated}>
                    Exportar Lista de Proyectos
                </BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={getinfo.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <div className="row">
                    <div className="col-md-12">
                        <Modal modal={modaldocdata} updateModal={setModaldocdata} >
                            <div className="row">
                                <div className="col-md-12">
                                    {formatodata?.DataBeanProperties?.URLLink && (
                                        // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                        <div className="row">
                                            <div className="col-md-12 mt-3">
                                                <label>Descarga en el Siguiente Link:*</label>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <a href={formatodata.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                    <strong>📄 {formatodata.DataBeanProperties.Filename}</strong>
                                                </a>
                                            </div>
                                        </div>

                                    )}
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modaldoc} updateModal={setModaldoc} >
                            <div className="row">
                                <div className="col-md-12">
                                    {formato?.DataBeanProperties?.URLLink && (
                                        // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                        <div className="row">
                                            <div className="col-md-12 mt-3">
                                                <label>Descarga en el Siguiente Link:*</label>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <a href={formato.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                    <strong>📄 {formato.DataBeanProperties.Filename}</strong>
                                                </a>
                                            </div>
                                        </div>

                                    )}
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                            <AutoChart data={lista.filter((item) => item.DataBeanProperties.Type != null)} head={head} useIndexAsXLabel={true}
                                xOptions={['AccountantIDName', 'AccountName', 'Code', 'Name']}
                                yOptions={['TotalValue', 'InitialValue', 'EndingValue', 'IDProject']} />

                        </Modal>
                    </div>
                    {/* <div className="col-md-12">
                        <Modal modal={modalgenerate} updateModal={setModalgenerate} eventModal={exportProjectData} onSubmit={'Generar Balance Financiero'}>
                            <div className="row">
                                <strong>Desea Generar Balance Financiero ?</strong>
                            </div>
                        </Modal>
                    </div> */}
                    <div className="col-md-12">
                        <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                            <>
                                <DocumentsForProjectData documentsTable={documentsTable} tableName={tableName} idProject={getinfo.bean.IDProject} />
                            </>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modaldocpres} updateModal={setModaldocpres}>
                            <>
                                <BudgetDocuments idProject={getinfo.bean.IDProject} />
                            </>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalpaa} updateModal={setModalpaa}>
                            <>
                                <AdquisitionItemByPaa idProject={getinfo.bean.IDProject} />
                            </>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalcontrac} updateModal={setModalcontrac}>
                            <>
                                <AdquisitionContractByAdquisition idProject={getinfo.bean.IDProject} />
                            </>
                        </Modal>
                    </div>
                    <div className="col-md-12">
                        <Modal modal={modalfacturas} updateModal={setModalfacturas}>
                            <>
                                <UBLInvoiceFactory IDProject={getinfo.bean.IDProject} isMenu />;
                            </>
                        </Modal>
                    </div>
                </div>
            </div>

        </div>
    )
}